export enum NodeId {
  HEADER = 'yohrs-header',
  CONTENT = 'yohrs-content',
}
